import React from "react"

import ItemDetailsColumns from "../../../common/columns/ItemDetailsColumns"
import ItemDetailsColumn from "../../../common/columns/ItemDetailsColumn"
import FeedItemConceptDetails from "../FeedItemConceptDetails"
import ViewFeedItemPublishingDetails from "./ViewFeedItemPublishingDetails"
import ViewFeedItemArticleDetails from "./ViewFeedItemArticleDetails"
import ViewFeedItemInsightDetails from "./ViewFeedItemInsightDetails"
import ViewFeedItemMedia from "./ViewFeedItemMedia"
import ViewFeedItemSource from "./ViewFeedItemSource"
import ViewFeedItemCreator from "./ViewFeedItemCreator"
import KnowledgeFingerprintWidget from "../KnowledgeFingerprintWidget"

export default ({
    model,
    isFetching,
    fulltext,
    isFetchingFulltext,
}) => (
    <form name="form">
        <ItemDetailsColumns className="article-item-container">
            <ItemDetailsColumn>
                <div id="source">
                    <ViewFeedItemPublishingDetails
                        publisher={model.publisher}
                        title={model.title}
                        link={model.link}
                        time={model.time}
                        timeAnalyzed={model.time_analyzed}
                        image={model.image}
                        language={model.language}
                        isFetching={isFetching}
                    />
                </div>
                <div>
                    <ViewFeedItemSource
                        source={model.source}
                        publisherDetails={model.publisher_details}
                        isFetching={isFetching}
                    />
                </div>
                <div>
                    <ViewFeedItemCreator
                        creator={model.creator}
                        publisher={model.publisher}
                        isFetching={isFetching}
                    />
                </div>
                <div id="insights">
                    <ViewFeedItemInsightDetails
                        topics={model.topics}
                        isFetching={isFetching}
                    />
                </div>
                {!isFetching && model.fp_topics && model.fp_topics.length ? (
                    <div>
                        <ViewFeedItemInsightDetails
                            header="Fingerprint topics"
                            topics={model.fp_topics}
                            isFetching={isFetching}
                            showScore={true}
                        />
                    </div>
                ) : null}
                {!isFetching && model.static_topics && model.static_topics.length ? (
                    <div>
                        <ViewFeedItemInsightDetails
                            header="Legacy static topics"
                            topics={model.static_topics}
                            isFetching={isFetching}
                            showScore={true}
                        />
                    </div>
                ) : null}
                {!isFetching && (model.attachment || model.embedded_media) && (
                    <div>
                        <ViewFeedItemMedia
                            attachment={model.attachment}
                            embeddedMedia={model.embedded_media}
                        />
                    </div>
                )}
            </ItemDetailsColumn>
            <ItemDetailsColumn>
                <div id="article">
                    <ViewFeedItemArticleDetails
                        fulltext={fulltext}
                        isFetchingFulltext={isFetchingFulltext}
                        summary={model.summary}
                        authors={model.authors}
                        license={model.license}
                        isFetching={isFetching}
                    />
                </div>
                <div id="concepts">
                    <FeedItemConceptDetails
                        concepts={model.concepts}
                        canEdit={false}
                        isFetching={isFetching}
                    />
                </div>
                {!isFetching && model.fp && model.fp.length ? (
                    <div id="fp">
                        <KnowledgeFingerprintWidget fingerprint={model.fp} />
                    </div>
                ) : null}
            </ItemDetailsColumn>
        </ItemDetailsColumns>
    </form>
)
